import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { SET_RUNNING_CALLS, SHOW_LIST_ONGOING } from '../store';
import { BASE_URL, getAvatarInitials } from '../helper/constants';
import { callAPI } from '../helper/apiUtils';
import MaterialIcon from './MaterialIcon';
import './OngoingCallsListPopup.css';
import LanguageContext from '../helper/LanguageContext';
import { stripMarkdown, truncateGroupName } from "../utils/conversationUtils";
import { openCallTab, markCallActive, unmarkCallActive } from "../utils/callTab";


function OngoingCallsListPopup({ reduxImages }) {
    const dispatch = useDispatch()
    const { strings } = useContext(LanguageContext);
    const showListOngoing = useSelector(e => e.showListOngoing)
    const runningCalls = useSelector(e => e.runningCalls)
    const getInitials = (name) => {
        if (!name) return "";
        const cleanedName = name.replace(/[^a-zA-Z\s]/g, "").trim();
        const parts = cleanedName.split(/\s+/);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return cleanedName.substring(0, 2).toUpperCase();
    };
    const getProjectName = (name) => getAvatarInitials(name);
    const onClickOfEndButton = (group) => {
        let newRunningCalls = runningCalls.filter(e => e.groupId != group.groupId);
        if (newRunningCalls.length === 0) {
            dispatch({ type: SHOW_LIST_ONGOING, payload: false })
        }
        dispatch({ type: SET_RUNNING_CALLS, payload: newRunningCalls })
    }
    const _startJitsiCall = async (group) => {
        markCallActive(group.groupId)
        openCallTab({ roomId: group.groupId, roomName: group.groupName, isGroupChat: !group.isOneToOne })
        dispatch({ type: SHOW_LIST_ONGOING, payload: false })
        try {
            await callAPI(`/videochat/join`, {}, "POST", { room: group.groupId, joinOnly: true });
        } catch (err) {
            unmarkCallActive(group.groupId)
        }
    }


    return (
        showListOngoing ?
            <div className="ongoing-calls-popup">
                <div onClick={() => {
                    dispatch({ type: SHOW_LIST_ONGOING, payload: false })
                }} className="ongoing-calls-popup__close">
                    <div className="ongoing-calls-popup__close-inner">
                        <span className="material-symbols-outlined ongoing-calls-popup__close-icon">
                            close
                        </span>
                    </div>
                </div>
                <div className="chat-list-container">
                    {(Array.isArray(runningCalls) ? runningCalls : []).map((group) => (
                        <div className="chat-group ongoing-call-row" key={group.id || group.groupId}>
                            {group.isOneToOne ? (
                                group.callerAvatar ? (
                                    <img
                                        src={`${BASE_URL}${group.callerAvatar}`}
                                        alt=""
                                        className="ongoing-call-avatar"
                                    />
                                ) : (
                                    <div className="ongoing-call-avatar-fallback">
                                        {getInitials(group.callerName || group.groupName)}
                                    </div>
                                )
                            ) : (
                                <div className="icon-container">{getProjectName(group.buildingName)}</div>
                            )}
                            <div className="chat-info">
                                <span className="chat-title">
                                    {group.isOneToOne
                                        ? `Anruf von ${group.callerName || truncateGroupName(stripMarkdown(group.groupName)) || ''} gestartet.`
                                        : `Anruf in der Chat Gruppe ${truncateGroupName(stripMarkdown(group.groupName)) || ''} im Projekt ${group.buildingName} gestartet.`
                                    }
                                </span>
                            </div>
                            <div className="ongoing-call-actions">
                                <div className="video-call-action" onClick={() => _startJitsiCall(group)}>
                                    <MaterialIcon icon="check_circle" size={28} color="#4CAF50" />
                                    <span className="video-call-action-label ongoing-calls-popup__label--join">{strings.join_call}</span>
                                </div>
                                <div className="video-call-action" onClick={() => onClickOfEndButton(group)}>
                                    <MaterialIcon icon="cancel" size={28} color="#e53935" />
                                    <span className="video-call-action-label ongoing-calls-popup__label--reject">{strings.reject}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            :
            <></>
    )
}

export default OngoingCallsListPopup